import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import type { ColumnCellRendererParams, PropertyViewModelInterface } from '@nts/std/interfaces';

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class BaseCellRendererComponent implements AgRendererComponent, OnInit, OnChanges, OnDestroy {

  @Input()
  params: ICellRendererParams;

  protected destroy$: Subject<boolean> = new Subject<boolean>();

  // Supporto dei componenti usati anche inclusi in altri componenti di template vedi dynamic
  ngOnInit(): void {
    if (this.params) {
      this.agInit(this.params);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['params']) {
      this._propertyViewModel = undefined;
    }
  }

  refresh(params: any): boolean {
    return true;
  }

  agInit(params: any): void {
    this.params = params;
    this._propertyViewModel = undefined;
  }

  private _propertyViewModel: PropertyViewModelInterface;

  get propertyViewModel(): PropertyViewModelInterface {
    if (!this._propertyViewModel) {
      this._propertyViewModel = (this.params as ColumnCellRendererParams).columnInfo.fieldName.split('.').reduce(
        (o, i) => {
          if (i === 'value') {
            return o;
          }
          if (o != null) {
            return o[i];
          }
          return null;
        }, this.params.data) as PropertyViewModelInterface;
    }
    return this._propertyViewModel;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.destroy$.unsubscribe();
  }
}
